/* tslint:disable */

/* ********************************************************
 * THIS FILE IS AUTO GENERATED BY A TOOL - DO NOT CHANGE IT
 * RUN npm run openapi-client-gen TO REGENERATE THE FILE
 * *******************************************************/

import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { AktivitetType } from '../models/aktivitet-type';
import { AktivitetTypeReference } from '../models/aktivitet-type-reference';
@Injectable({
  providedIn: 'root',
})
class ProjekterAktiviteterService extends __BaseService {
static readonly getAktivitetTyperForProjektPath = '/projekter/{projektId}/aktivitetstyper';
static readonly addAktivitetTypeToProjektPath = '/projekter/{projektId}/aktivitetstyper';
static readonly removeAktivitetTypeFromProjektPath = '/projekter/{projektId}/aktivitetstyper/{aktivitetTypeId}/{regelkonfigurationId}';
static readonly removeAktivitetTyperFromProjektPath = '/projekter/{projektId}/aktivitetstyper/removeactivities';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param projektId undefined
   * @return Success
   */
  private getAktivitetTyperForProjektResponse(projektId: string): __Observable<__StrictHttpResponse<Array<AktivitetType>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/projekter/${encodeURIComponent(String(projektId))}/aktivitetstyper`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<AktivitetType>>;
      })
    );
  }

  /**
   * @param projektId undefined
   * @return Success
   */
  getAktivitetTyperForProjekt(projektId: string): __Observable<Array<AktivitetType>> {
    return this.getAktivitetTyperForProjektResponse(projektId).pipe(
      __map(_r => _r.body as Array<AktivitetType>)
    );
  }

  /**
   * Tilføjer en aktivitetstype til et projekt.
   * @param params The `ProjekterAktiviteterService.AddAktivitetTypeToProjektParams` containing the following parameters:
   *
   * - `projektId`: Projektets ID.
   *
   * - `sagToReplaceId`: Erstatter en eksisterende sag med den nye aktivitetstype.
   *
   * - `aktivitetTypeRef`: Aktivitetstype reference.
   *
   * @return Success
   */
  private addAktivitetTypeToProjektResponse(params: ProjekterAktiviteterService.AddAktivitetTypeToProjektParams): __Observable<__StrictHttpResponse<AktivitetType>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.sagToReplaceId != null) __params = __params.set('sagToReplaceId', params.sagToReplaceId.toString());
    __body = params.aktivitetTypeRef;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/projekter/${encodeURIComponent(String(params.projektId))}/aktivitetstyper`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AktivitetType>;
      })
    );
  }

  /**
   * Tilføjer en aktivitetstype til et projekt.
   * @param params The `ProjekterAktiviteterService.AddAktivitetTypeToProjektParams` containing the following parameters:
   *
   * - `projektId`: Projektets ID.
   *
   * - `sagToReplaceId`: Erstatter en eksisterende sag med den nye aktivitetstype.
   *
   * - `aktivitetTypeRef`: Aktivitetstype reference.
   *
   * @return Success
   */
  addAktivitetTypeToProjekt(params: ProjekterAktiviteterService.AddAktivitetTypeToProjektParams): __Observable<AktivitetType> {
    return this.addAktivitetTypeToProjektResponse(params).pipe(
      __map(_r => _r.body as AktivitetType)
    );
  }

  /**
   * @param params The `ProjekterAktiviteterService.RemoveAktivitetTypeFromProjektParams` containing the following parameters:
   *
   * - `regelkonfigurationId`:
   *
   * - `projektId`:
   *
   * - `aktivitetTypeId`:
   *
   * - `sagId`:
   */
  private removeAktivitetTypeFromProjektResponse(params: ProjekterAktiviteterService.RemoveAktivitetTypeFromProjektParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;



    if (params.sagId != null) __params = __params.set('sagId', params.sagId.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/projekter/${encodeURIComponent(String(params.projektId))}/aktivitetstyper/${encodeURIComponent(String(params.aktivitetTypeId))}/${encodeURIComponent(String(params.regelkonfigurationId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }

  /**
   * @param params The `ProjekterAktiviteterService.RemoveAktivitetTypeFromProjektParams` containing the following parameters:
   *
   * - `regelkonfigurationId`:
   *
   * - `projektId`:
   *
   * - `aktivitetTypeId`:
   *
   * - `sagId`:
   */
  removeAktivitetTypeFromProjekt(params: ProjekterAktiviteterService.RemoveAktivitetTypeFromProjektParams): __Observable<null> {
    return this.removeAktivitetTypeFromProjektResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param params The `ProjekterAktiviteterService.RemoveAktivitetTyperFromProjektParams` containing the following parameters:
   *
   * - `projektId`:
   *
   * - `aktivitetTypeReferencer`:
   */
  private removeAktivitetTyperFromProjektResponse(params: ProjekterAktiviteterService.RemoveAktivitetTyperFromProjektParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.aktivitetTypeReferencer;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/projekter/${encodeURIComponent(String(params.projektId))}/aktivitetstyper/removeactivities`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }

  /**
   * @param params The `ProjekterAktiviteterService.RemoveAktivitetTyperFromProjektParams` containing the following parameters:
   *
   * - `projektId`:
   *
   * - `aktivitetTypeReferencer`:
   */
  removeAktivitetTyperFromProjekt(params: ProjekterAktiviteterService.RemoveAktivitetTyperFromProjektParams): __Observable<null> {
    return this.removeAktivitetTyperFromProjektResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }
}

module ProjekterAktiviteterService {

  /**
   * Parameters for addAktivitetTypeToProjekt
   */
  export interface AddAktivitetTypeToProjektParams {

    /**
     * Projektets ID.
     */
    projektId: string;

    /**
     * Erstatter en eksisterende sag med den nye aktivitetstype.
     */
    sagToReplaceId?: string;

    /**
     * Aktivitetstype reference.
     */
    aktivitetTypeRef?: AktivitetTypeReference;
  }

  /**
   * Parameters for removeAktivitetTypeFromProjekt
   */
  export interface RemoveAktivitetTypeFromProjektParams {
    regelkonfigurationId: string;
    projektId: string;
    aktivitetTypeId: string;
    sagId?: string;
  }

  /**
   * Parameters for removeAktivitetTyperFromProjekt
   */
  export interface RemoveAktivitetTyperFromProjektParams {
    projektId: string;
    aktivitetTypeReferencer?: Array<AktivitetTypeReference>;
  }
}

export { ProjekterAktiviteterService }
